  <!-- MIGAS DE PAN Y TÍTULO -->
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="bg-second-migas">
    <div class="container mt-cab-fixed">
      <div class="pre-content">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Acuerdo indirecto</li>
            <li class="breadcrumb-item">Prefacturas y facturas</li>
          </ol>
        </nav>
        <div class="content-title">
          <h2 class="title-pag">Búsqueda Prefacturas y facturas</h2>

        </div>
      </div>
    </div>
  </div>
  <!-- FIN MIGAS DE PAN Y TÍTULO -->
  <!-- CONTENIDO -->

  <div class="container-form">
  <!-- Barra de filtros aplicados -->
    <div class="filtros-bar">
      <div class="filtros-aplicados">
        <span class="filtros-label">Filtros aplicados</span>
        <span *ngFor="let filtro of filtrosAplicados" class="filtro-chip">
          {{filtro.label}}
          <button type="button" class="chip-remove" (click)="quitarFiltro(filtro)">×</button>
        </span>
      </div>
      <button type="button" class="btn-toggle-filtros" (click)="toggleFiltros()">
        <mat-icon>tune</mat-icon>
        {{ mostrarFiltros ? 'Ocultar Filtros' : 'Ver Filtros' }}
      </button>
    </div>
  <!-- Formulario de búsqueda -->
  <form *ngIf="mostrarFiltros" class="container-fluid form-search py-3" [formGroup]="searchForm">
<div class="d-flex flex-wrap" style="gap: 1rem;">        <div style="flex: 1 1 300px; max-width: 400px;">
          <ng-container>
            <label for="gestor">Razón Social Gestor - NIMA - Centro </label>
            <div class="custom-mat-field">
              <lib-ge-select-pagination [endPointFilter]="listaGestores" [multiple]=true [updateList]="updateList"
              [placeHolder]="'--Gestores--'" [formControlNameSelect]="getFormControl('gestor')"
              [descripcion]="getGestorDescription" [objQueryName]="getGestorObjectQuery" [customClass]="rightHolder('gestor')"
              [defaultParameters]="defaultGestoresParameters">
            </lib-ge-select-pagination>
            </div>
          </ng-container>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="canViewResource('AI-GESTOR')">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --" multiple>
                <mat-option *ngFor="let des of estadoArray" [value]="des">
                  {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 150px; max-width: 200px;" *ngIf="!canViewResource('AI-GESTOR')">
          <ng-container>
            <label for="idgestor">ID. Gestor </label>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <input matInput formControlName="idgestor" id="idgestor" placeholder="ID. Gestor" type="text" (keydown)="onlyNumberCommaKey($event)">
              </mat-form-field>
            </div>
          </ng-container>
        </div>
        <div style="flex: 1 1 180px; max-width: 250px;" *ngIf="!canViewResource('AI-GESTOR')">
          <ng-container>
            <label for="codigo_documento">Documento (NIE, NIF) </label>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <input matInput formControlName="codigo_documento" id="codigo_documento"
                  placeholder="Documento (NIE, NIF)" type="text">
              </mat-form-field>
            </div>
          </ng-container>
        </div>
        <!--<div class="col-sm flex-grow-1" *ngIf="!canViewResource('AI-GESTOR')">
          <ng-container>
            <label for="razon_social">Razón Social </label>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <input matInput formControlName="razon_social" id="razon_social" placeholder="Razón Social" type="text">
              </mat-form-field>
            </div>
          </ng-container>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="!canViewResource('AI-GESTOR')">
          <ng-container>
            <label for="nima_gestor">NIMA del gestor </label>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <input matInput formControlName="nima_gestor" id="nima_gestor" placeholder="NIMA del gestor"
                  type="text">
              </mat-form-field>
            </div>
          </ng-container>
        </div>-->

        <div style="flex: 1 1 200px; max-width: 300px;">
          <label for="numero_autoFactura">Número de prefactura </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="numero_autoFactura" id="numero_autoFactura"
                placeholder="Número de prefactura " type="text" maxlength="10" (keydown)="onlyNumberKey($event)">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 190px; max-width: 190px;">
          <label for="fecha_autoFactura">Fecha de prefactura </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput [matDatepicker]="datepicker" formControlName="fecha_autoFactura">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_autoFactura', 'matDatepickerParse')">Formato incorrecto
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;">
          <label for="numero_facturaGestor">Número factura gestor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="numero_facturaGestor" id="numero_facturaGestor"
                placeholder="Número factura gestor" type="text" maxlength="20">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 190px; max-width: 190px;">
          <label for="fecha_facturaGestor">Fecha factura gestor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput [matDatepicker]="datepickerFacturaGestor" formControlName="fecha_facturaGestor">
              <mat-datepicker-toggle matIconSuffix [for]="datepickerFacturaGestor"></mat-datepicker-toggle>
              <mat-datepicker #datepickerFacturaGestor>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_facturaGestor', 'matDatepickerParse')">Formato incorrecto
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="!canViewResource('AI-GESTOR')">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --" multiple>
                <mat-option *ngFor="let des of estadoArray" [value]="des">
                  {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1" *ngIf="canViewRegistrada()">
          <label for="registrada">Registrada</label>
          <div class="custom-mat-field">
            <mat-checkbox formControlName="registrada" color="primary"></mat-checkbox>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="canViewResource('AI-ENV-GEST') || canViewResource('AI-ENV-CONS')">
          <label for="registrada">Abono</label>
          <div class="custom-mat-field">
            <mat-checkbox formControlName="abonoS" color="primary" (change)="onAbonoChange('S',$event.checked)">Sí</mat-checkbox>
            <mat-checkbox formControlName="abonoN" color="primary" (change)="onAbonoChange('N',$event.checked)">No</mat-checkbox>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('AI-ENV-GEST') || canViewResource('AI-ENV-CONS')">
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
                <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('AI-ENV-GEST') || canViewResource('AI-ENV-CONS')">
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
                <mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

      </div>

    </form>
        <form class="container-fluid form-search py-3">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>
    <!-- FIN Formulario de búsqueda -->
  </div>
  <div class="bg-second-table-info pt-3 pb-5">
    <div *ngIf="flagSearch; else messageClear" class="container">
      <div class="actions-table">
        <div class=""><span class="align-middle tit-table">{{ recordsTotal }} registros encontrados</span></div>
        <div class="text-right" *ngIf="canAccessExport()">
          <div class="d-inline">

            <div class="d-flex d-inline dropdown show">
              <button *ngIf="canAccessInformeContabilizacion()" type="button" class="btn btn-primary margin-bton-informe"
                data-toggle="modal" (click)="openModalAccounting()"><span class="icon-add"></span>Informe
                contabilización</button>
              <a (click)="exportarExcel()" class="btn btn-outline-primary" role="button" aria-haspopup="true"
                aria-expanded="false">
                <span class="mr-3">Exportar</span></a>
            </div>
          </div>
        </div>
      </div>
      <div class="card-tabla-proy">
        <div class="card-body">
          <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
            <div class="datatable-container table-responsive">
              <!-- TABLA Listado con resultados de búsqueda -->
              <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (checked)="checked($event)"
                (actionButton)="action($event)"></lib-ge-table>
              <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
                <div class="d-flex mt-2">
                  <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                    (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                  </ngb-pagination>
                </div>

                <div class="mt-2 selectPage">
                  <label for="itemsPerPage">Mostrar:</label>
                  <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                    <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                  </select>
                </div>
              </div>
              <!-- FIN TABLA Listado con resultados de búsqueda -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #messageClear>
      <div class="mensaje-container">
        <p class="mensaje-linea">No hay resultados de búsqueda, por favor seleccione, al menos, un criterio en el
          formulario</p>
        <p class="mensaje-linea"></p>
      </div>
    </ng-template>
  </div>
